import React from "react";
import { Outlet } from "react-router-dom";
import { MantineProvider } from "@mantine/core";

export default function ShopWrapper() {
  return (
    <MantineProvider withGlobalStyles withNormalizeCSS>
      <Outlet />
    </MantineProvider>
  );
}
